import { render, staticRenderFns } from "./bigAwardDetail.vue?vue&type=template&id=88729b12&"
import script from "./bigAwardDetail.vue?vue&type=script&lang=js&"
export * from "./bigAwardDetail.vue?vue&type=script&lang=js&"
import style0 from "./bigAwardDetail.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports